import axios from 'axios'

const request = axios.create({
  baseURL: 'https://api.fjhzrc.com' // 线上
  // baseURL: 'http://192.168.1.163:8007/api' // 阿玺本地
})

request.interceptors.response.use(
  function (response) {
    if (response.data.code === 500) {
      return Promise.reject(response.data.msg)
    } else if (response.data.code === 501) {
      return Promise.reject(response.data.msg)
    } else if (response.data.code === 301) {
      return Promise.reject(response.data.msg)
    } else if (response.data.code === 404) {
      return Promise.reject(response.data.msg)
    }
    return response
  },
  function (err) {
    return Promise.reject(err)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/util/request.js